import React from 'react';
import { Button, Carousel, Container, Row } from 'react-bootstrap';
import './SingleWorks.css';
import { useParams } from 'react-router';
import projects from '../../../../Data/projects';

const SingleWorks = () => {

    let allProjects = projects;
    const { id } = useParams();
    
    const alldetails = allProjects.filter(service => service.key === parseInt(id));

    return (
        <>
            <section className="singleworks">
                <Container>
                    <Row>
                        <div className="py-4">
                            <div>
                                <Carousel>
                                    {
                                        alldetails[0]?.img.map((image, i) =>
                                            <Carousel.Item interval={1000}>
                                
                                    
                                                <img
                                                    className="d-block w-100"
                                                    src={image.images}
                                                    alt="First slide"
                                                />
                                
                                            </Carousel.Item>
                                        )
                                    }
                                </Carousel>
                            </div>
                            <div className="technology my-3">
                                    
                                {
                                    alldetails[0]?.technology.map((tech, i) =>
                                        <span>{tech.use}</span>
                                    )
                                }
                            </div>
                            <div className="text-light my-5 project-details">
                                <h1>Project Name: {alldetails[0]?.title}</h1>
                                <p>About Project: {alldetails[0]?.about} </p>
                            </div>
                            <div className="text-light feature-list">
                                <h3>Feature</h3>
                                <ul>
                                    {
                                        alldetails[0]?.description.map((details, i) =>
                                            <li>{details.power}</li>
                                        )
                                    }
                                </ul>
                            </div>
                        
                            <div className="text-light feature-list">
                                <h3>Preview And Source Code</h3>
                                <ul className="preview list-inline mt-4">
                                    {
                                        alldetails[0]?.git.map((code, i) =>
                                            <li className="list-inline-item">
                                                <a href={code.link}>
                                                    <Button style={{ backgroundImage: 'linear-gradient(90deg,#f61b10,#ef0963)', border: 'none', fontSize: '30px' }} className="text-btn fs-6 fw-bold mb-2">{code.codes}</Button>
                                                </a>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default SingleWorks;